import React, { useEffect, useState } from 'react';
import { signOut } from 'firebase/auth';
import { auth, db } from '../firebase';
import { collection, getDocs, doc, updateDoc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import logo from '../assets/logo.png';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { storage } from '../firebase';
import { FaDownload, FaTimes } from 'react-icons/fa';

export default function Dashboard() {
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const [boloens, setBoloens] = useState([]);
  const [fileNames, setFileNames] = useState({});
  const [loadingStates, setLoadingStates] = useState({});
  const [pastedFiles, setPastedFiles] = useState({});
  const [previewUrls, setPreviewUrls] = useState({});

  useEffect(() => {
    const fetchBoloes = async () => {
      const bolaoSnapshot = await getDocs(collection(db, 'bolao'));
      const boloesList = bolaoSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setBoloens(boloesList);
    };
    fetchBoloes();
  }, []);

  const handleLogout = async () => {
    await signOut(auth);
    localStorage.clear();
    navigate('/');
  };

  const handleFileChange = (e, bolaoId) => {
    const file = e.target.files[0];
    if (file) {
      setFileNames(prev => ({ ...prev, [bolaoId]: file.name }));
      removePastedImage(bolaoId);
    }
  };

  const handlePaste = (e, bolaoId) => {
    const items = e.clipboardData.items;
    for (const item of items) {
      if (item.type.indexOf('image') !== -1) {
        const blob = item.getAsFile();
        const pastedFile = new File([blob], `comprovante_colado_${Date.now()}.png`, { type: blob.type });

        setPastedFiles(prev => ({ ...prev, [bolaoId]: pastedFile }));
        const previewUrl = URL.createObjectURL(pastedFile);
        setPreviewUrls(prev => ({ ...prev, [bolaoId]: previewUrl }));

        setFileNames(prev => ({ ...prev, [bolaoId]: '' }));
        const fileInput = document.getElementById(`comprovante-${bolaoId}`);
        if (fileInput) {
            fileInput.value = '';
        }
        break;
      }
    }
  };
  
  const removePastedImage = (bolaoId) => {
    if (previewUrls[bolaoId]) {
      URL.revokeObjectURL(previewUrls[bolaoId]);
    }
    setPastedFiles(prev => {
        const newState = { ...prev };
        delete newState[bolaoId];
        return newState;
    });
    setPreviewUrls(prev => {
        const newState = { ...prev };
        delete newState[bolaoId];
        return newState;
    });
  };

  const handleSubmit = async (e, bolao, idx) => {
    e.preventDefault();
    setLoadingStates(prev => ({ ...prev, [bolao.id]: true }));

    const nome = currentUser?.displayName || currentUser?.email;
    const cotasDesejadas = parseInt(e.target.cotas.value, 10);
    
    const pastedFile = pastedFiles[bolao.id];
    const selectedFile = e.target.comprovante.files[0];
    const file = pastedFile || selectedFile;

    const cotasUtilizadas = bolao.participantes.reduce((acc, p) => acc + p.cotas, 0);
    const cotasRestantes = bolao.totalCotas - cotasUtilizadas;

    if (!nome || !cotasDesejadas || cotasDesejadas <= 0 || !file) {
      alert("Preencha o número de cotas e anexe ou cole o comprovante.");
      setLoadingStates(prev => ({ ...prev, [bolao.id]: false }));
      return;
    }

    if (cotasDesejadas > cotasRestantes) {
      alert(`Você não pode comprar mais cotas do que as ${cotasRestantes} restantes.`);
      setLoadingStates(prev => ({ ...prev, [bolao.id]: false }));
      return;
    }

    try {
      const bolaoRef = doc(db, 'bolao', bolao.id);
      const filePath = `comprovantes/${currentUser?.uid}_${Date.now()}_${file.name}`;
      const storageRef = ref(storage, filePath);
      await uploadBytes(storageRef, file);
      const fileUrl = await getDownloadURL(storageRef);

      const novaLista = [...(bolao.participantes || []), { nome, cotas: cotasDesejadas, comprovanteUrl: fileUrl }];

      await updateDoc(bolaoRef, { participantes: novaLista });

      setBoloens(prev => {
        const novo = [...prev];
        novo[idx].participantes = novaLista;
        return novo;
      });

      alert("Participante incluído com sucesso!");
      e.target.reset();
      setFileNames(prev => ({ ...prev, [bolao.id]: '' }));
      removePastedImage(bolao.id);

    } catch (err) {
      console.error("Erro ao incluir participante:", err);
      alert("Erro ao incluir participante. Por favor, tente novamente.");
    } finally {
      setLoadingStates(prev => ({ ...prev, [bolao.id]: false }));
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <img src={logo} alt="Logo" style={{ width: '120px', marginBottom: '1rem' }} />
        </div>
        <h2 style={{ margin: '0 0 0.5rem', fontSize: '2rem', fontWeight: 'bold' }}>Bem-vindo, {currentUser?.displayName || 'usuário'}!</h2>
      </div>

      <button onClick={handleLogout} style={styles.logout}>Sair</button>

      {boloens.map((bolao, idx) => {
        const cotasUtilizadas = bolao.participantes.reduce((acc, p) => acc + p.cotas, 0);
        const cotasRestantes = bolao.totalCotas - cotasUtilizadas;
        const arrecadado = cotasUtilizadas * bolao.valorCota;
        const isLoading = loadingStates[bolao.id] || false;
        
        const currentFileName = fileNames[bolao.id] || '';
        const pastedFilePreview = previewUrls[bolao.id];

        // Verifica se há números sorteados e se nenhum deles é 0
        const shouldShowResult = bolao.numerosSorteados && bolao.numerosSorteados.length > 0 && !bolao.numerosSorteados.includes(0);

        return (
          <div key={idx} style={styles.card}>
            <div style={{ textAlign: 'center' }}>
              <h3 style={{ margin: '0 0 0.5rem', fontSize: '1.5rem', fontWeight: 'bold' }}>{bolao.tipo} - Concurso {bolao.concurso} - {bolao.data}</h3>
            </div>

            <table style={styles.table}>
              <tbody>
                <tr>
                  <td style={styles.tableCell}><strong>Prêmio estimado</strong></td>
                  <td style={styles.tableCell}><strong>Total de cotas</strong></td>
                  <td style={styles.tableCell}><strong>Valor da cota</strong></td>
                </tr>
                <tr>
                  <td style={styles.tableCell}>R$ {Number(bolao.premio || 0).toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}</td>
                  <td style={styles.tableCell}>{bolao.totalCotas}</td>
                  <td style={styles.tableCell}>R$ {bolao.valorCota.toLocaleString('pt-BR')}</td>
                </tr>
                <tr>
                  <td style={styles.tableCell}><strong>Cotas utilizadas</strong></td>
                  <td style={styles.tableCell}><strong>Cotas restantes</strong></td>
                  <td style={styles.tableCell}><strong>Total arrecadado</strong></td>
                </tr>
                <tr>
                  <td style={styles.tableCell}>{cotasUtilizadas}</td>
                  <td style={styles.tableCell}>{cotasRestantes}</td>
                  <td style={styles.tableCell}>R$ {arrecadado.toLocaleString('pt-BR')}</td>
                </tr>
              </tbody>
            </table>

            {/* Tabela de Apostas */}
            <div style={styles.apostasContainer}>
              <h4 style={styles.sectionTitle}>Apostas Realizadas</h4>
              {bolao.apostas && bolao.apostas.length > 0 ? (
                <table style={styles.table}>
                  <thead>
                    <tr>
                      <th style={styles.tableHeader}>Números Apostados</th>
                      <th style={styles.tableHeader}>Valor da Aposta</th>
                    </tr>
                  </thead>
                  <tbody>
                    {bolao.apostas.map((aposta, i) => (
                      <tr key={i}>
                        <td style={styles.tableCell}>
                          <div style={styles.numerosLista}>
                            {aposta.numerosAposta.map((num, j) => (
                              <div key={j} style={styles.numero}>{num}</div>
                            ))}
                          </div>
                        </td>
                        <td style={styles.tableCell}>R$ {aposta.valorAposta.toLocaleString('pt-BR')}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <p style={{ textAlign: 'center', color: '#666' }}>Nenhuma aposta registrada para este bolão.</p>
              )}
            </div>

            {shouldShowResult && ( // Condição para exibir o resultado do sorteio
              <div style={styles.numerosSorteadosContainer}>
                <h4 style={styles.sectionTitle}>Resultado do Sorteio</h4>
                <div style={styles.numerosLista}>
                  {bolao.numerosSorteados.map((numero, i) => (
                    <div key={i} style={styles.numero}>{numero}</div>
                  ))}
                </div>
              </div>
            )}

            {/* Centralizar e remover os dois pontos do label "Participantes" */}
            <h4 style={{ ...styles.sectionTitle, marginTop: shouldShowResult ? '2.5rem' : '1.5rem', textAlign: 'center' }}>Participantes</h4>
            <table style={styles.table}>
              <thead>
                <tr>
                  <th style={styles.tableHeader}>#</th>
                  <th style={styles.tableHeader}>Nome</th>
                  <th style={styles.tableHeader}>Cotas</th>
                  <th style={styles.tableHeader}>Pix</th>
                </tr>
              </thead>
              <tbody>
                {bolao.participantes.map((p, i) => (
                  <tr key={i}>
                    <td style={styles.tableCell}>{i + 1}</td>
                    <td style={styles.tableCell}>{p.nome}</td>
                    <td style={styles.tableCell}>{p.cotas}</td>
                    {/* APLICAÇÃO DO FLEXBOX DIRETAMENTE NA TD COM ESTILO `downloadCell` */}
                    <td style={styles.tableCell}> {/* Mantém o estilo da célula normal */}
                      <div style={styles.downloadIconWrapper}> {/* Novo wrapper para flexbox */}
                        <a href={p.comprovanteUrl} target="_blank" rel="noopener noreferrer" style={styles.downloadIconLink}>
                          <FaDownload />
                        </a>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            <h4 style={{ marginTop: '2rem', fontWeight: 'bold' }}>Participar deste bolão:</h4>
            <form onSubmit={(e) => handleSubmit(e, bolao, idx)} onPaste={(e) => handlePaste(e, bolao.id)}>
                <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap', marginBottom: '1rem' }}>
                    <input
                        name="cotas" type="number" placeholder="Cotas"
                        style={styles.input} min="1" max={cotasRestantes}
                        required disabled={isLoading}
                    />
                    <input
                        name="comprovante" id={`comprovante-${bolao.id}`} type="file"
                        accept="image/*,application/pdf" style={{ display: 'none' }}
                        onChange={(e) => handleFileChange(e, bolao.id)} disabled={isLoading}
                    />
                    <label htmlFor={`comprovante-${bolao.id}`} style={{...styles.fileUploadButton, cursor: isLoading ? 'not-allowed' : 'pointer', flexGrow: 1}}>
                        {currentFileName || "Anexar Comprovante"}
                    </label>
                </div>
                <div style={{border: '2px dashed #ccc', padding: '1rem', borderRadius: '8px', textAlign: 'center' }}>
                    <p style={{ margin: 0, color: '#666', fontSize: '0.9rem', fontWeight: 'bold' }}>
                        Cole a imagem do comprovante aqui ou anexe acima.
                    </p>
                </div>
                {pastedFilePreview && (
                    <div style={styles.previewContainer}>
                        <span style={{ marginRight: '10px', fontWeight: 'bold' }}>Comprovante Colado:</span>
                        <img src={pastedFilePreview} alt="Preview" style={styles.previewImage} />
                        <button type="button" onClick={() => removePastedImage(bolao.id)} style={styles.removeButton}>
                            <FaTimes />
                        </button>
                    </div>
                )}
                {/* O botão "Incluir no Bolão" foi movido para cá, após a caixa de colagem do comprovante */}
                <button type="submit" style={{...styles.button, marginTop: '1rem', width: '100%'}} disabled={isLoading}>
                    {isLoading ? (<div style={spinnerStyle}></div>) : ("Incluir no bolão")}
                </button>
            </form>
          </div>
        );
      })}
    </div>
  );
}

const spinnerStyle = {
    border: '4px solid rgba(255, 255, 255, 0.3)',
    borderTop: '4px solid #fff',
    borderRadius: '50%',
    width: '20px',
    height: '20px',
    animation: 'spin 1s linear infinite',
    display: 'inline-block',
};

const styles = {
    container: { padding: '2rem', backgroundColor: '#f5f5f5', minHeight: '100vh', position: 'relative' },
    header: { textAlign: 'center', marginBottom: '2rem' },
    logout: { position: 'absolute', bottom: '20px', left: '50%', transform: 'translateX(-50%)', padding: '0.5rem 1rem', backgroundColor: '#ccc', border: 'none', borderRadius: '6px', cursor: 'pointer', zIndex: 1000 },
    card: { background: 'white', padding: '1.5rem', borderRadius: '12px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)', width: '100%', maxWidth: '600px', margin: '0 auto 2rem' },
    table: { width: '100%', borderCollapse: 'collapse', marginTop: '1rem', textAlign: 'center' },
    tableHeader: { border: '1px solid #ddd', padding: '8px', backgroundColor: '#f2f2f2' }, // Cabeçalho cinza
    tableCell: { border: '1px solid #ddd', padding: '8px', textAlign: 'center', backgroundColor: 'white' }, // Células brancas
    // Estilo para a célula do ícone de download - aplicado diretamente à TD
    downloadCell: {
        display: 'flex',
        justifyContent: 'center', // Centraliza horizontalmente
        alignItems: 'center',    // Centraliza verticalmente
        padding: '0',            // Zera o padding da TD para evitar espaçamento indesejado
        height: 'auto',          // Garante que a altura se ajuste ao conteúdo
    },
    // Estilo para o link do ícone de download
    downloadIconLink: { 
        color: '#4CAF50',
        display: 'flex', // Garante que o link seja um container flex
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%', // Para que o link ocupe toda a largura da célula
        height: '100%', // Para que o link ocupe toda a altura da célula
        textDecoration: 'none', // Remove sublinhado padrão
        padding: '8px', // Adiciona padding ao link para restaurar o espaçamento visual
        boxSizing: 'border-box', // Garante que o padding não aumente o tamanho total
    },
    apostasContainer: { marginTop: '1.5rem', textAlign: 'center', padding: '1rem', borderRadius: '8px' }, // Removido o background aqui
    numerosSorteadosContainer: { marginTop: '1.5rem', textAlign: 'center', background: '#f0f0f0', padding: '1rem', borderRadius: '8px' },
    // Estilo compartilhado para os títulos das seções "Apostas Realizadas", "Resultado do Sorteio" e "Participantes"
    sectionTitle: {
      marginTop: '0',
      marginBottom: '1rem',
      color: '#333',
      fontSize: '1.25rem', // Aumenta um pouco a fonte
      fontWeight: 'bold',  // Coloca em negrito
      textAlign: 'center' // Adicionado para centralizar
    },
    numerosLista: { display: 'flex', justifyContent: 'center', gap: '10px', flexWrap: 'wrap' },
    numero: { backgroundColor: '#4CAF50', color: 'white', borderRadius: '50%', width: '36px', height: '36px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold' },
    input: { padding: '0.75rem', border: '1px solid #ddd', borderRadius: '6px', flexGrow: 1 },
    button: { padding: '0.75rem 1.5rem', backgroundColor: '#4CAF50', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: 'bold', display: 'flex', alignItems: 'center', justifyContent: 'center' },
    fileUploadButton: { padding: '0.75rem', border: '1px solid #ddd', borderRadius: '6px', backgroundColor: '#e0e0e0', color: '#333', cursor: 'pointer', textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', minWidth: '150px' },
    previewContainer: { display: 'flex', alignItems: 'center', marginTop: '1rem', padding: '10px', backgroundColor: '#e8f5e9', border: '1px solid #a5d6a7', borderRadius: '6px', position: 'relative' },
    previewImage: { maxHeight: '40px', borderRadius: '4px', border: '1px solid #ccc' },
    removeButton: { background: 'transparent', color: '#c62828', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0', fontSize: '1.2rem', marginLeft: 'auto' }
};
